/**
 * Modelos de Transacciones
 */

export interface TransaccionBanco {
  ID?: string;
  id?: string;
  banco: string;
  cuenta: string;
  fecha: string;
  fechaValuta?: string;
  descripcion: string;
  tipo: 'ENTRADA' | 'SALIDA' | string;
  monto: string | number;
  saldo: string | number;
  operacion?: string;
  horaOperacion?: string;
  usuario?: string;
  referencia?: string;
  estado?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TransaccionInput {
  id?: string;
  banco: string;
  cuenta: string;
  fecha: string;
  fechaValuta?: string;
  descripcion: string;
  tipo: 'ENTRADA' | 'SALIDA' | string;
  monto: string | number;
  saldo: string | number;
  operacion?: string;
  horaOperacion?: string;
  usuario?: string;
  referencia?: string;
}

export interface DeudorCobranza {
  nombre: string;
  tipo: 'PERSONA' | 'EMPRESA' | string;
}

export interface AccountStatementCobranza {
  id: string;
  clientId: string;
  clientName: string;
  period: string;
  startDate: string;
  endDate: string;
  dueDate: string;
  createdAt: string;
}

export interface CobranzaItem {
  id: string;
  estado: string;
  tipoIngreso: string;
  categoriaIngreso: string;
  subcategoriaIngreso: string;
  numberOI?: string;
  monto: number;
  moneda: 'PEN' | 'USD';
  deudor: DeudorCobranza;
  accountStatement?: AccountStatementCobranza;
}

export interface Cobranza {
  id: string;
  createdAt: string;
  fechaEfectiva?: string;
  estado: string;
  moneda: 'PEN' | 'USD';
  listaOI?: CobranzaItem[];
}

export interface NiubizDetails {
  orderNumber?: string;
  cardBrand?: string;
  settlementDate?: string;
  status?: string;
  merchantCode?: string;
  authorizationDate?: string;
  PAN?: string;
  authorizationCode?: string;
  issuer?: string;
  cardType?: string;
}

export interface Trip {
  name?: string;
  id?: string;
  startDate?: string;
  endDate?: string;
}

export interface Fees {
  weTravelFee?: number;
  organizerCardFee?: number;
  customerCardFee?: number;
  transferFee?: number;
}

export interface Participant {
  name?: string;
  email?: string;
}

export interface WeTravelDetails {
  dateUpdated?: string;
  transactionType?: string;
  paymentMethod?: string;
  netAmount?: number;
  amount?: number;
  description?: string;
  reference?: string;
  paymentPurpose?: string;
  runningBalance?: number;
  transactionId?: string;
  fees?: Fees;
  participants?: Participant[];
  trip?: Trip;
  package?: string;
}

export interface TransaccionTC {
  id: string;
  platform: string;
  currency: string;
  orderAmount: number;
  transactionDate: string;
  transactionCode: string;
  cardholderEmail: string;
  clientName: string;
  estado?: string;
  cobranzaId?: string;
  comision?: number;
  pi?: any;
  niubizDetails?: NiubizDetails;
  weTravelDetails?: WeTravelDetails;
}
